import { render } from "./Tsv.vue?vue&type=template&id=68b5bc44&scoped=true"
import script from "./Tsv.vue?vue&type=script&lang=js"
export * from "./Tsv.vue?vue&type=script&lang=js"

import "./Tsv.vue?vue&type=style&index=0&id=68b5bc44&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b5bc44"],['__file',"src/components/element/Tsv.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68b5bc44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68b5bc44', __exports__)) {
    api.reload('68b5bc44', __exports__)
  }
  
  module.hot.accept("./Tsv.vue?vue&type=template&id=68b5bc44&scoped=true", () => {
    api.rerender('68b5bc44', render)
  })

}


export default __exports__